import FormControl from "@mui/material/FormControl"
import InputBase from "@mui/material/InputBase"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { styled } from "@mui/styles"
import { defaultTo } from "ramda"

export const StyledFormControl = styled(FormControl)(({ width, height }) => {
  return {
    "&.MuiFormControl-root": {
      "& .MuiFormHelperText-root": {
        marginLeft: 0,
      },
      margin: 0,
    },
    display: "inherit",
    minWidth: 200,
    width,
    height,
  }
})

export const StyledInputLabel = styled(InputLabel)(() => {
  return {
    "&.MuiInputLabel-root": {
      "&[class*=MuiInputLabel-root].Mui-focused": {
        color: "#0000008a",
      },
      "&[data-shrink='true']": {
        fontSize: "1.6rem",
      },
      color: "#0000008a",
      fontSize: "1.4rem",
    },
    marginTop: -4,
  }
})

export const StyledSelect = styled(Select)(({ theme: { typography } }) => ({
  borderRadius: 4,
  height: typography.pxToRem(44),
}))

export const StyledInput = styled(InputBase)((props) => {
  const {
    background = "#F1F3F4",
    color,
    fontColor,
    labeled,
    theme: { typography, withPalette },
  } = props

  return {
    "& .MuiInputBase-input": {
      "&:focus": {
        backgroundColor: defaultTo(withPalette(color), background),
        borderRadius: 4,
      },
      borderRadius: 4,
      color: withPalette(color, "contrastText", fontColor),
      fontSize: typography.pxToRem(14),
      paddingBottom: labeled ? 0 : 10,
      paddingLeft: 12,
      paddingRight: 45,
      paddingTop: labeled ? 20 : 11,
    },
    "&.MuiInputBase-root": {
      paddingTop: 0,
    },
    alignItems: "center",
    backgroundColor: defaultTo(withPalette(color), background),
    display: "inline-flex",
  }
})

export const StyledMenuItem = styled(MenuItem)(({ theme: { typography } }) => ({
  "&.MuiMenuItem-root": {
    "&[aria-selected='true']": {
      "&.Mui-selected": {
        backgroundColor: "#efefef",
      },
    },
    borderBottom: "1px solid #ebebeb",
    color: "#554854",
    fontSize: typography.pxToRem(14),
    fontWeight: "bold",
    minWidth: typography.pxToRem(230),
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(20)}`,
  },
}))
